export const addClass = (targetId, classAdding) => {
  let el = document.getElementById(targetId);
  el.classList.contains(classAdding) ? null : el.classList.add(classAdding);
};

export const removeClass = (targetId, classRemoving) => {
  let el = document.getElementById(targetId);
  el.classList.contains(classRemoving)
    ? el.classList.remove(classRemoving)
    : null;
};

export const confirmHasClass = (targetId, classChecking) => {
  let el = document.getElementById(targetId);
  console.log("element targeting returns "+el);
  console.log(typeof el !== "undefined");
  console.log(classChecking);
  console.log(el.classList);
  console.log(el.classList.contains(classChecking));
  if(typeof el !== "undefined"){
    return(el.classList.contains(classChecking));
  }else{
    return false;
  }
};

export const confirmIdStyle = (targetId, styleChecking) => {
  let el = document.getElementById(targetId);
  alert(el.display.style === styleChecking);
    return el.display.style === styleChecking;
};

export const setIdStyle = (targetId, styleSetting) => {
  let el = document.getElementById(targetId);
  el.display.style = styleSetting;
};


export const changeClassApplied=(id, classChecking, classDefault, classPrimary, classSecondary) =>{
  if(confirmHasClass(id, classDefault)){
      removeClass(id, classDefault);
  }
  
  if(confirmHasClass(id, classChecking)){
      removeClass(id, classPrimary);
      addClass(id, classSecondary);
  }else{
    removeClass(id, classSecondary);
    addClass(id, classPrimary);
  }
}

export const changeClassApplied_noDefault=(id, classChecking, classPrimary, classSecondary) =>{
  // console.log("has class is: "+confirmHasClass(id, classChecking));
  if(confirmHasClass(id, classChecking)){
      removeClass(id, classPrimary);
      addClass(id, classSecondary);
  }else{
    removeClass(id, classSecondary);
    addClass(id, classPrimary);
  }
}

export const toggleClass=(id, classChecking) =>{
  // console.log("has class is: "+confirmHasClass(id, classChecking));
  if(confirmHasClass(id, classChecking)){
      removeClass(id, classChecking);
  }else{
    addClass(id, classChecking);
  }
}

export const toggleVisibility_ById=(id, displayStyle) =>{
  alert("triggered for id "+id+" checking for style of: "+displayStyle);
  alert(confirmIdStyle(id, displayStyle));
  confirmIdStyle(id, displayStyle) ?
    setIdStyle(id, "none") && alert("hide")
    : 
    setIdStyle(id, displayStyle) && alert("show");
}

// export const toggleVisibility_ById=(id, displayStyle, hideOnly) =>{
//   confirmIdStyle(id, displayStyle) ?
//     setIdStyle(id, "none") 
//     : 
//     ( hideOnly ? null : setIdStyle(id, displayStyle) );
// }

export const hideAll_ByClass=(targetClass, clickedId) =>{
  let x = document.getElementsByClassName(targetClass);
  let numId = returnFirstNum_FromTxt(clickedId.id, "-");
  for(var i=0; i< x.length; i++){
    x[i].classList.remove("visible");
    if(returnFirstNum_FromTxt(x[i].id, "-") === numId){
      x[i].classList.add("visible");
      }
  }
}

export const returnFirstNum_FromTxt=(val, seperator) =>{
  // console.log(typeof val);
  let num = val.substring(0, val.indexOf(seperator));
  return num;
}